var $class="se2--header-se--mega-menu",$name="HeaderSE/megaMenu",$path="app/components/HeaderSE/partials/megaMenu/index.js",$this={$class,$name,$path,};import {
  closeClassName,
  openClassName,
  menuItemClassName,
  menuNavButtonClassName,
  showClassName,
  closeDesktopMenuButtonSelector,
  level1ButtonPopupSelector,
  level1ItemSelector,
  level2ButtonSelector,
} from 'app/components/HeaderSE/partials/megaMenu/config';

import shell from 'app/modules/shell';

import isMobileBreakpoint from 'app/utilities/isMobileBreakpoint';
import { isHeaderVersion8 } from 'app/components/HeaderSE/utilities/isHeaderVersion8';

import { css, messages } from 'configs';

import forEach from 'lodash/forEach';
import debounce from 'lodash/debounce';
import initializeSlider from 'app/components/utilities/initializeSlider';

export default shell.registerPartial($this, (
  { addEventListener, mount, publishMessage },
) => {
  function showLevel2MenuInMobile(l2btn) {
    l2btn.classList.toggle(css.classNames.hide);
    const { nextElementSibling } = l2btn;
    nextElementSibling?.firstElementChild.classList.toggle(showClassName);
    nextElementSibling?.classList.toggle(closeClassName);
  }

  mount((element) => {
    const menuNavButtons = element.querySelectorAll(`.${menuNavButtonClassName}`);
    const menuItems = element.querySelectorAll(`.${menuItemClassName}`);
    const level2Buttons = element.querySelectorAll(level2ButtonSelector);
    const closeDesktopMenuButtonElement = element.querySelector(`${closeDesktopMenuButtonSelector}`);

    addEventListener(closeDesktopMenuButtonElement, 'click',
      () => publishMessage(messages.userClickedMegaMenuCloseButtonOnDesktop,
        { selector: closeDesktopMenuButtonSelector }));

    let [activeMenuNavButton] = menuNavButtons;
    let [activeLevel2Item] = menuItems;
    function initSliderMegaMenu() {
      if (!activeLevel2Item.dataset.sliderChecked && !isMobileBreakpoint()) {
        const sliderContainer = activeLevel2Item.querySelector('.mm-slider-container.level2-list-logo');
        activeLevel2Item.dataset.sliderChecked = '1';
        if (sliderContainer) {
          initializeSlider(activeLevel2Item,
            addEventListener,
            {
              containerSelector: '.mm-slider-container',
              notMMSlides: false,
            });
        }
      }
    }

    const observerCallback = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          initSliderMegaMenu();
        }
      }
    };

    const observer = new IntersectionObserver(observerCallback);
    observer.observe(element);

    if (!isMobileBreakpoint()) {
      activeMenuNavButton?.classList.add(css.classNames.active);
      activeLevel2Item?.classList.remove(css.classNames.hide);
    }

    function showOnMobile(buttonElement, index) {
      buttonElement.classList.toggle(openClassName);
      forEach(level2Buttons, showLevel2MenuInMobile);

      forEach(
        menuNavButtons,
        (el) => {
          if (buttonElement !== el) {
            el.classList.toggle(css.classNames.hide);
          }
        },
      );
      buttonElement.closest(level1ItemSelector).querySelector(level1ButtonPopupSelector)
        .classList.toggle(closeClassName, buttonElement.classList.contains(openClassName));

      element.classList.toggle(css.classNames.expanded);
      menuItems[index].classList.toggle(css.classNames.hide);
    }

    function showOnDesktop(buttonElement, index) {
      activeMenuNavButton.classList.remove(css.classNames.active);
      activeLevel2Item.classList.add(css.classNames.hide);
      buttonElement.classList.add(css.classNames.active);
      menuItems[index].classList.remove(css.classNames.hide);
      activeMenuNavButton = buttonElement;
      activeLevel2Item = menuItems[index];

      initSliderMegaMenu();
    }

    forEach(
      menuNavButtons,
      (button, i) => {
        const debouncedItem = debounce(() => showOnDesktop(button, i), 500);

        isMobileBreakpoint()
          ? addEventListener(button, 'click', () => showOnMobile(button, i))
          : addEventListener(button, 'mouseover', () => debouncedItem());

        if (!isMobileBreakpoint()) {
          addEventListener(button, 'mouseout', () => debouncedItem.cancel());
        }
      },
    );

    function onWindowResize() {
      activeMenuNavButton?.classList.toggle(css.classNames.active, !isMobileBreakpoint());
      if (!isHeaderVersion8()) activeLevel2Item?.classList.toggle(css.classNames.hide, isMobileBreakpoint());

      const openedBtnIdx = Array.from(menuNavButtons).findIndex((btn) => btn.classList.contains(openClassName));

      if (isMobileBreakpoint()) {
        activeMenuNavButton.classList.add(css.classNames.active);
        menuNavButtons[openedBtnIdx]?.classList.remove(css.classNames.active);
      } else if (menuNavButtons[openedBtnIdx]) {
        forEach(level2Buttons, showLevel2MenuInMobile);
        forEach(menuNavButtons, ({ classList }) => classList.remove(css.classNames.hide));

        menuNavButtons[openedBtnIdx].closest(level1ItemSelector).querySelector(level1ButtonPopupSelector)
          .classList.remove(closeClassName);

        element.classList.remove(css.classNames.expanded);
        menuItems[openedBtnIdx]?.classList.toggle(css.classNames.hide);
        menuNavButtons[openedBtnIdx].classList.remove(openClassName);
      }
    }

    addEventListener(window, 'resize', onWindowResize);
  });
});
